import FirestoreModel from './FirestoreModel'

class Workspace extends FirestoreModel {
  collectionName = 'workspaces'
  constructor(firebase) {
    super(firebase)
    this.setCollection(this.collectionName)
  }

  async getInvited(invitedWorkspaces, userId) {
    //Merge invited workspaces
    let rtn = []
    const collection = this.firestore().collection(this.collectionName)

    let promises = []
    try {
      invitedWorkspaces.forEach((ws) => {
        promises.push(
          collection
            .where(this.firestore.FieldPath.documentId(), '==', ws.workspace)
            .get()
        )
      })
      const workspaces = (await Promise.all(promises))
        .map((snapshot) => snapshot.docs)
        .flat()

      workspaces.forEach((doc) => {
        const data = doc.data()
        if (data.memberIds.includes(userId))
          rtn.push({ id: doc.id, invited: true, ...doc.data() })
      })

      return rtn
    } catch (e) {
      console.error(e)
      return []
    }
  }
}
export default Workspace
